import { Row, Col } from 'react-bootstrap';
import CalculatedIncomeResults from '../../../common/CalculatedIncomeResults';
import CalculatedBenefitResults from '../../../common/CalculatedBenefitResults';
import CurrencyField from '../../../fields/CurrencyField';

const CaresGrantOnlySection = ({
  arrearsLiabilityAmount,
  onArrearsLiabilityAmountChange,
  incomeMeasurementType,
  incomeMeasurementPercentage,
  arrearage,
  energyDiscount,
  pledgeAmount,
  isSubmitting,
}) => {

  return (
    <>
      <hr/>
      {/* Income Information */}
      <Row className="mb-3">
        <Col md={6}>
          <h4>Income Information</h4>
          <CurrencyField
              value={arrearsLiabilityAmount}
              fieldName="Arrears Liability Amount"
              fieldId="arrears-liablity-amount"
              onChange={onArrearsLiabilityAmountChange}
              isSubmitting={isSubmitting}
              required
          />
          </Col>
      </Row>
      <>
        <CalculatedIncomeResults
          incomeMeasurementType={incomeMeasurementType}
          incomeMeasurementPercentage={incomeMeasurementPercentage}
          arrearage={arrearage}
          isSubmitting={isSubmitting}
        />

        <hr />
              
        {/* Benefit Amounts */}
        <CalculatedBenefitResults
          energyDiscount={energyDiscount}
          pledgeAmount={pledgeAmount}
        />
      </>
    </>
  );
};

export default CaresGrantOnlySection;